import React, { useEffect } from 'react';
import Drawer from "components/Drawers/Drawer";
import QuickPurchase from 'components/Drawers/DrawerQuickPurchase/QuickPurchase';
import { actionsType } from 'config/constants';
import QuickPurchaseCheckout from 'containers/QuickPurchaseCheckout'
import ModalClientUpdate from 'components/Checkout/CheckoutSteps/Resumendentification/ModalClientIdentification'
import ModalFailedPaymentBank from 'components/ModalFailedPaymentBank';
import ModalFailedPayment from 'components/ModalFailedPayment';
import ModalOrderDelivery from 'components/Checkout/CheckoutSteps/DeliveryMode/ModalOrderDelivery';
import { features, quickPurchaseID } from 'config';
import PubSub from 'services/PubSub'
import useVariant from 'hooks/useVariant'
import style from './style.scss'; //NOSONAR

const DrawerQuickPurchase= () => {
    if(!features.fastPurchase) return '';

    const variant = useVariant(quickPurchaseID);

    useEffect(()=> {
        if(variant) {
            const newVariant = variant === '1';
            if(!newVariant) PubSub.dispatch(actionsType.DRAWER.QUICK_PURCHASE_CLOSE);
        }
    },[variant])

    return (
        <Drawer 
            customClass={'drawer-quick-purchase'} 
            actionOpen={actionsType.DRAWER.QUICK_PURCHASE_OPEN} 
            actionClose={actionsType.DRAWER.QUICK_PURCHASE_CLOSE}>
            <QuickPurchaseCheckout>
                {(propsComponent) => {
                    return <QuickPurchase {...propsComponent} />
                }}
            </QuickPurchaseCheckout>
            <ModalClientUpdate/>
            <ModalFailedPaymentBank />
            <ModalFailedPayment />
            <ModalOrderDelivery />
        </Drawer>
    );
}

export default DrawerQuickPurchase;
